module.exports = __webpack_public_path__ + "static/media/guests-blue.83a4e17f.svg";